import { __awaiter } from "tslib";
import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';
import { selectToken } from './customer';
import { ReducerType } from './types';
const initialState = {
    entity: null,
    error: null,
    loading: 'idle'
};
export var QuoteActionType;
(function (QuoteActionType) {
    QuoteActionType["FetchQuote"] = "customer/fetchQuote";
})(QuoteActionType || (QuoteActionType = {}));
export const fetchQuote = createAsyncThunk(QuoteActionType.FetchQuote, (orderUuid, { getState, rejectWithValue }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const api = getState().config.api;
        const token = selectToken(getState());
        return yield api.getQuote(token, orderUuid);
    }
    catch (err) {
        return rejectWithValue(err);
    }
}));
const quoteSlice = createSlice({
    name: ReducerType.Quote,
    initialState,
    reducers: {
        resetQuote: () => initialState,
        resetQuoteError: state => {
            state.error = null;
            state.loading = 'idle';
        },
        setQuote: (state, action) => {
            state.entity = action.payload;
            state.error = null;
        }
    },
    extraReducers: builder => {
        builder
            .addCase(fetchQuote.fulfilled, (state, action) => {
            state.entity = action.payload;
            state.loading = 'idle';
            state.error = null;
        })
            .addCase(fetchQuote.pending, state => {
            state.loading = 'pending';
        })
            .addCase(fetchQuote.rejected, (state, action) => {
            state.error = action.payload;
            state.loading = 'idle';
        });
    }
});
export const { resetQuote, resetQuoteError, setQuote } = quoteSlice.actions;
export const selectQuote = createSelector((state) => {
    const { entity: order, loading, error } = state.quote;
    return { order, loading, error };
}, ({ order, loading, error }) => {
    return { order, loading, error };
});
export const quoteReducer = quoteSlice.reducer;
